/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authOrgsUpdateQuota } from "../../funcs/authOrgsUpdateQuota.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateOrgQuotaRequest$inboundSchema,
};

export const tool$authOrgsUpdateQuota: ToolDefinition<typeof args> = {
  name: "auth-orgs-update-quota",
  description: `Set an org's usage quota (cluster-admin)`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authOrgsUpdateQuota(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
